import type { Route } from 'vue-router';

export const ASSESSMENT_EXIT_ROUTE_NAMES = ['Start', 'Device', 'Summary'] as const;
export const ASSESSMENT_EXIT_ROUTE_PATHS = ['/start', '/device', '/preference/summary'] as const;

const ASSESSMENT_EXIT_ROUTE_NAME_SET = new Set<string>(ASSESSMENT_EXIT_ROUTE_NAMES);
const ASSESSMENT_EXIT_ROUTE_PATH_SET = new Set<string>(ASSESSMENT_EXIT_ROUTE_PATHS);

export function normalizeExitRoutePath(path?: string): string {
  if (!path) {
    return '';
  }

  return path !== '/' && path.endsWith('/') ? path.slice(0, -1) : path;
}

export function shouldClearContextOnLeave(to?: Partial<Route>): boolean {
  return ASSESSMENT_EXIT_ROUTE_NAME_SET.has(String(to?.name || ''))
    || ASSESSMENT_EXIT_ROUTE_PATH_SET.has(normalizeExitRoutePath(to?.path));
}


